import React from 'react';
import cx from 'classnames';
import _ from 'lodash';

import InfiniteScroll from 'components/InfiniteScroll';
import { ContentCard, ContentCardPlaceholder } from '../sectionManager/components/contentCard';
import { resolveDynamicContentMappingId } from './dynamicContentMappingIds';
import { usePersonalizationFilteredContents } from './PersonalizationShowSelectedContext';

import personalizeStyles from './personalization.module.scss';

export const PersonalizationDynamicPersonalizeGrid = ({
  containerRef,
  contents,
  loading,
  hasMoreItems,
  loadMore,
  activeAssetIds,
  onToggleAsset,
}) => {
  const displayContents = usePersonalizationFilteredContents(
    contents,
    activeAssetIds,
    resolveDynamicContentMappingId,
  );

  return (
    <div className={personalizeStyles.personalizeGridSection} ref={containerRef}>
      <InfiniteScroll
        className={personalizeStyles.personalizeGrid}
        loading={loading}
        hasMore={hasMoreItems}
        loadMore={loadMore}
      >
        {displayContents.map((data) => {
          const mappingId = resolveDynamicContentMappingId(data);
          const selected = mappingId ? activeAssetIds.includes(mappingId) : false;
          return (
            <div
              key={mappingId || _.get(data, 'content.id')}
              className={personalizeStyles.personalizeGridCard}
            >
              <ContentCard
                assetData={data}
                selected={selected}
                onSelect={() => {
                  if (!mappingId) return;
                  onToggleAsset(mappingId, !selected);
                }}
                className={cx({ [personalizeStyles.personalizeCardMuted]: !selected })}
              />
            </div>
          );
        })}
        {loading &&
          _.times(_.size(displayContents) === 0 ? 4 : 7).map((index) => (
            <ContentCardPlaceholder key={index} />
          ))}
      </InfiniteScroll>
    </div>
  );
};
